import { ALPHA_2_ISO_3166, PERSONAL_STATUS, RESIDENCE_PERMIT_TYPES, SALUTATIONS } from 'cpool-constants';
import { z } from 'zod';

import { Phone } from '../../utils/phone.utils';

export const Personendaten = z.object({
    anrede: z.nativeEnum(SALUTATIONS).nullish().default(null),
    arbeitserlaubnisBefristetBis: z.coerce.date().nullish(),
    arbeitserlaubnisVorhanden: z.boolean().nullish(),
    aufenthaltBefristetBis: z.coerce.date().nullish(),
    aufenthaltstitel: z.nativeEnum(RESIDENCE_PERMIT_TYPES).nullish(),
    email: z.string().email(),
    familienstand: z.nativeEnum(PERSONAL_STATUS).nullish().default(null),
    geburtsdatum: z.coerce.date(),
    geburtsland: z.nativeEnum(ALPHA_2_ISO_3166),
    geburtsname: z.string().min(1).nullish().default(null),
    geburtsort: z.string().min(1).nullish().default(null),
    inDeutschlandSeit: z.coerce.date().nullish(),
    nachname: z.string().min(1),
    staatsangehoerigkeit: z.nativeEnum(ALPHA_2_ISO_3166),
    telefonPrivat: Phone,
    vorname: z.string().min(1),
});

export type Schema_Personendaten = z.infer<typeof Personendaten>;
